module.exports = __webpack_public_path__ + "img/8_45.182b3923.png";